<template>
  <div>
    <el-card shadow="always">
      <el-form
        ref="formInline"
        size="medium"
        label-width="100px"
        :model="formInline"
        inline
      >
        <el-form-item prop="name" label="公开课名称">
          <el-input
            v-model="formInline.name"
            placeholder="请输入公开课名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="subjectId" label="所属科目">
          <el-select v-model="formInline.subjectId" placeholder="请选择">
            <el-option
              v-for="item in subjectData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-left: 30px">
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="handleReset" style="margin-left: 8px"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
      <br />
      <el-table
        border
        stripe
        v-loading="loading"
        :data="data"
        style="width: 100%"
      >
        <el-table-column type="index" label="序号" width="110" align="center">
        </el-table-column>
        <el-table-column label="公开课名称" minWidth="220" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.name || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="所属科目" minWidth="200" align="center">
          <template slot-scope="{ row }">
            <span>{{ handleSubject(row.subjectId) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" minWidth="220" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.insertDate || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          minWidth="150"
          fixed="right"
          align="center"
          label="操作"
        >
          <template slot-scope="{ row }">
            <span class="blue_Box" @click="openDownloadPoster(row)"
              >下载专属海报</span
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <my-pagination
        :page-info="pageInfo"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
    </el-card>

    <el-dialog
      title="课程海报"
      :visible.sync="dialogVisible"
      width="410px"
      :before-close="handleClose"
    >
      <img v-if="imgUrl" class="posterImage" :src="imgUrl" alt="" />
      <div v-else ref="poster" class="poster">
        <img
          crossOrigin="anonymous"
          id="image1"
          class="posterBg"
          :src="posterBg"
        />
        <img
          id="image2"
          class="qrcode1"
          :src="`${url}/adm/bktOpenClass/getWxCode?page=detailPage/coursedetail/index&scene=saleId-${$myStore.state.user.userId}`"
        />
      </div>
      <div style="text-align: center">
        <el-button style="margin-top: 10px" type="primary" @click="downLoad"
          >下载</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getBktSubjectListPage } from "@/api/videoReference/account.js";
import { getBktOpenClassListPage } from "@/api/videoReference/regulate.js";
import myPagination from "@/components/myPagination.vue";
import { clone, processing } from "@/utils/handle.js";
import { baseURL } from "@/api/request";
import html2canvas from "html2canvas";
import { getpublicImgUrl, ossAccountInfo } from "@/api/base/api-upload";
let OSS = require("ali-oss");
export default {
  components: {
    myPagination,
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      imgUrl: "",
      posterBg: "",
      baseURL,
      formInline: {
        name: "",
        subjectId: "",
      },
      data: [],
      subjectData: [],
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0,
      },
      searchData: {},
      row: {},
    };
  },
  computed: {
    url() {
      if (this.baseURL.lastIndexOf("/") === this.baseURL.length - 1) {
        return this.baseURL.slice(0, this.baseURL.length - 1);
      }
      return this.baseURL;
    },
  },
  mounted() {
    this.getBktSubjectListPage();
    this.getBktOpenClassListPage({ page: 1, limit: 10 });
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.imgUrl = "";
      this.posterBg = "";
    },
    // 下载专属海报
    openDownloadPoster(row) {
      if (row.publishStatus === 1) {
        this.$message({
          message: "该公开课未发布，暂不能生成",
          type: "warning",
        });
        return;
      }

      this.posterBg = row.posterUrl;
      this.row = row;
      this.dialogVisible = true;

      const img1 = document.querySelector("#image1");
      const img2 = document.querySelector("#image2");
      const timer = setInterval(() => {
        if (img1 || img2) {
          if (img1.complete && img2.complete) {
            const _that = this;
            clearInterval(timer);
            html2canvas(this.$refs.poster, {
              useCORS: true,
            }).then((canvas) => {
              var fileImage = _that.blobToFile(
                _that.dataURLToBlob(canvas.toDataURL())
              );
              _that.uploadImg(fileImage);
            });
          }
        } else {
          clearInterval(timer);
        }
      }, 50);
    },
    downloadIamge(imgsrc, name) {
      // 下载图片地址和图片名
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png"); // 得到图片的base64编码数据
        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "photo"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
    downLoad() {
      if (!this.imgUrl) {
        this.$message({
          message: "请等待图片加载完",
          type: "warning",
        });
        return;
      }
      this.downloadIamge(this.imgUrl, "海报");
    },
    blobToFile(theBlob) {
      theBlob.lastModifiedDate = new Date();
      theBlob.name = this.randomString(10) + "s.png";
      return theBlob;
    },
    // 生成随机字符串
    randomString(len) {
      len = len || 32;
      var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
      var maxPos = chars.length;
      var pwd = "";
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    dataURLToBlob(dataurl) {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    uploadImg(fileImage) {
      // 公有
      let client = new OSS({
        region: res.data.endpoint,
        region: 'oss-cn-beijing',
        accessKeyId: 'LTAI5tBf21wbwbNGRw6giHmJ',
        accessKeySecret: 'HyiGrcwGRq4K1fwCYG2FRiPKC19t2h',
        bucket: 'jsw-public',
        useFetch: false,
      });
      // 1 -  文件上传到阿里云，获取到地址
      client
        .put("wap/pub/upload/" + fileImage.name, fileImage)
        .then((result) => {
          //  2 - 根据文件名称获取文件私有路径
          getpublicImgUrl("wap/pub/upload/" + fileImage.name).then((res) => {
            this.imgUrl = res.data;
          });
        });
    },
    // 科目列表
    async getBktSubjectListPage() {
      const res = await getBktSubjectListPage({ page: 1, limit: -1 });
      this.subjectData = res.data?.records || [];
    },
    // 筛选对应科目
    handleSubject(payload) {
      let arr = this.subjectData.find((item) => {
        return item.id === payload;
      });
      return arr?.name || "--";
    },
    // 列表请求
    async getBktOpenClassListPage(payload) {
      this.loading = true;
      this.pageInfo.page = payload.page;
      this.pageInfo.limit = payload.limit;
      const res = await getBktOpenClassListPage(payload);
      this.data = res.data?.records || [];
      this.pageInfo.total = Number(res.data?.total) || 0;
      this.loading = false;
    },
    handleSearch() {
      this.searchData = processing(this.formInline);
      this.getBktOpenClassListPage(
        Object.assign(processing(this.formInline), {
          page: 1,
          limit: 10,
        })
      );
    },
    handleReset() {
      this.searchData = {};
      this.$refs["formInline"].resetFields();
      this.getBktOpenClassListPage({
        page: 1,
        limit: 10,
      });
    },
    // 切换页数
    handleCurrentChange(payload) {
      this.getBktOpenClassListPage(
        Object.assign(clone(this.searchData), {
          page: payload,
          limit: this.pageInfo.limit,
        })
      );
    },
    // 切换每页条数
    handleSizeChange(payload) {
      this.getBktOpenClassListPage(
        Object.assign(clone(this.searchData), { page: 1, limit: payload })
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/index.scss";
.posterImage {
  width: 375px;
}
.poster {
  width: 375px;
  position: relative;
  .posterBg {
    width: 375px;
  }
  .qrcode {
    position: absolute;
    left: 50%;
    bottom: 74px;
    transform: translateX(-50%);
    width: 104px;
    height: 104px;
  }
  .qrcode1 {
    position: absolute;
    right: 44px;
    bottom: 44px;
    width: 80px;
    height: 80px;
  }
}
</style>
